import React, { useState } from 'react';
import ReportPrintFrame from './ReportPrintFrame';

export default function ReportPreviewMock({ settings, identity, reportTitle = 'نموذج تقرير', scale: initialScale = 0.62 }) {
  const [zoom, setZoom] = useState(initialScale);
  const s = settings || {};
  const isLandscape = s.page?.orientation === 'landscape';
  const boxW = isLandscape ? 842 : 595;
  const cellStyle = { padding: s.page?.table_density === 'compact' ? '3px 6px' : '6px 8px', verticalAlign: 'middle', lineHeight: 1.6 };

  return (
    <div className="rounded-xl border border-slate-200 bg-slate-100 p-3" data-testid="report-preview-box">
      <div className="mb-2 flex items-center justify-end gap-1" data-testid="report-preview-zoom-controls">
        <button type="button" onClick={() => setZoom((z) => Math.max(0.35, +(z - 0.1).toFixed(2)))} className="h-6 w-6 rounded-lg border border-slate-200 bg-white text-sm font-bold text-slate-500 hover:bg-slate-50" data-testid="report-preview-zoom-out">−</button>
        <span className="w-12 text-center text-xs font-semibold text-slate-500" data-testid="report-preview-zoom-value">{Math.round(zoom * 100)}٪</span>
        <button type="button" onClick={() => setZoom((z) => Math.min(1.2, +(z + 0.1).toFixed(2)))} className="h-6 w-6 rounded-lg border border-slate-200 bg-white text-sm font-bold text-slate-500 hover:bg-slate-50" data-testid="report-preview-zoom-in">+</button>
      </div>
      <div className="overflow-auto">
        <div style={{ width: boxW * zoom, transformOrigin: 'top right' }}>
          <div style={{ width: boxW, transform: `scale(${zoom})`, transformOrigin: 'top right', background: '#fff', boxShadow: '0 2px 10px rgba(0,0,0,0.08)' }}>
            <ReportPrintFrame settings={s} identity={identity} reportTitle={reportTitle} exportedByName="اسم المستخدم">
              <div className="space-y-3">
                {s.content?.stat_cards !== false && (
                  <div className="grid grid-cols-4 gap-2">
                    {['١٢٤', '٤٥', '٩٨٪', '٣٢'].map((v, i) => (
                      <div key={i} style={{ border: `1px solid ${s.page?.show_table_borders !== false ? '#e2e8f0' : 'transparent'}`, borderRadius: 8, padding: '8px' }}>
                        <div style={{ fontSize: 16, fontWeight: 800, color: s.page?.header_color || '#16233b' }}>{v}</div>
                        <div style={{ fontSize: 9, color: '#64748b' }}>مؤشر تجريبي</div>
                      </div>
                    ))}
                  </div>
                )}
                {s.content?.tables !== false && (
                  <table style={{ width: '100%', fontSize: 10, borderCollapse: 'collapse' }}>
                    <thead>
                      <tr style={{ background: s.page?.table_header_color || '#16233b', color: '#fff' }}>
                        <th style={{ ...cellStyle, textAlign: 'right' }}>البيان</th>
                        <th style={{ ...cellStyle, textAlign: 'right' }}>التاريخ</th>
                        <th style={{ ...cellStyle, textAlign: 'right' }}>القيمة</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[1, 2, 3].map((r) => (
                        <tr key={r} style={{ borderBottom: s.page?.show_table_borders !== false ? '1px solid #e2e8f0' : 'none' }}>
                          <td style={cellStyle}>عنصر تجريبي {r}</td>
                          <td style={cellStyle}>٢٠٢٦-٠١-٠{r}</td>
                          <td style={cellStyle}>١٬٢٠٠</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
                {s.content?.charts && (
                  <div style={{ display: 'flex', gap: 4, alignItems: 'flex-end', height: 50 }}>
                    {[30, 45, 20, 38, 50].map((h, i) => <div key={i} style={{ width: 14, height: h, background: s.page?.header_color || '#16233b', opacity: 0.7, borderRadius: 2 }} />)}
                  </div>
                )}
              </div>
            </ReportPrintFrame>
          </div>
        </div>
      </div>
    </div>
  );
}
